import { useFastCommentsCount } from '@/components/FastCommentWidget';
import CommentOutline from '@simplywallst/ui-core/icons/CommentOutline';
import { Button } from '@simplywallst/ui-core/next';
import { useTracking } from 'react-tracking';
type Props = {
  commentKey: string;
  onCommentClick: () => void;
};

export const CommentNarrative = ({ commentKey, onCommentClick }: Props) => {
  const { commentCount } = useFastCommentsCount(commentKey);
  const { trackEvent } = useTracking({
    type: 'track',
    subject: 'narrative',
    action: 'comment',
    commentKey,
  });

  return (
    <Button
      variant="outline"
      size="medium"
      onClick={() => {
        trackEvent();
        onCommentClick();
      }}
      className="px-x1"
    >
      <CommentOutline />
      {commentCount > 0 ? commentCount : null}
    </Button>
  );
};
